import React, { useState, useContext, useEffect } from 'react';

import moment from 'moment';

import { feedbackTimeout, RequestTypeMapping, RequestorMapping, v2UIRoutePath } from '../../../common/commons';
import FormGroup from '../FormGroup';
import { isReportRightApplicable, mapReportValues } from './reportRights';

import axios from '../../../common/AxiosConfig';

import { AppContext } from '../../../../RoutesWithAuth';

import {Snackbar, Box, IconButton, Tooltip, Typography, Checkbox, FormControlLabel, ToggleButtonGroup, ToggleButton } from '@mui/material';

import { CardLayoutView, REQUEST_TYPES } from './AgingReportViews';

import CustomGrid from '../customgrid';

import Dialog from '../Dialog';

import GetAppIcon from '@mui/icons-material/GetApp';

import { makeStyles } from "@mui/styles";

import ReportPopup from './ReportCommonPopup';

import Papa from 'papaparse';

import { Link, useLocation } from 'react-router-dom';

import { Alert } from '@mui/lab';

const useStyles = makeStyles(() => ({
    dialogheader: {
        textAlign: 'center',
        fontSize: '0.75rem',
        '& span': {
            fontWeight: 'bold'
        },
        '& .modelheader': {
            paddingBottom: '5px',
            fontWeight: 'bold'
        }
    },
    agingReportHeader: {
        padding: '10px 0px 5px 10px',
        fontSize: '1rem',
        fontWeight: 'bold',
        borderBottom: '1px solid #dedfdf',
        marginBottom: '5px',
        marginRight: '10px'
    },
    downstreamMetricsHeader: {
        fontSize: '1rem',
        fontWeight: 'bold',
        padding: '10px 0px 5px 10px',
    },
    requestStatusInput: {
        width: '95px',
    },
    toggleButtonGroup: {
        margin: '10px 0 5px 10px',
        padding: '4px',
        backgroundColor: '#eef1f5',
        borderRadius: '10px',
        border: 'none',
        '& .MuiToggleButtonGroup-grouped': {
            border: 'none',
            borderRadius: '10px !important',
            '&:not(:first-of-type)': {
                marginLeft: '4px',
            },
        },
        '& .MuiToggleButton-root': {
            textTransform: 'none',
            fontSize: '0.85rem',
            padding: '5px 24px',
            color: '#5f6b7a',
            fontWeight: 500,
            border: 'none',
            outline: 'none',
            transition: 'all 0.2s ease',
            '&:focus': {
                outline: 'none',
                border: 'none',
                boxShadow: 'none',
            },
            '&.Mui-selected': {
                backgroundColor: '#fff',
                color: '#1a1a1a',
                fontWeight: 600,
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                '&:hover': {
                    backgroundColor: '#fff',
                },
            },
            '&:not(.Mui-selected)': {
                backgroundColor: 'transparent',
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.5)',
                    color: '#1a1a1a',
                },
            },
        },
    },
    root: {
        '& .btngridcel': {
            background: "transparent",
            border: "0px solid transparent",
            outline: "0px",
            padding: '0px',
            fontSize: 'inherit'
        }
    },
    dialogWrapper: {
        width: '860px'
    }
}))

function AgingReport(props) {

    const context = useContext(AppContext)
    const authToken = context.authToken.get
    const classes = useStyles();

    const todayUTC = moment().utc();
    const location = useLocation();
    const routeState = location?.state;

    const [rtdBreakdown, setRtdBreakdown] = useState([])
    const [rtkBreakdown, setRtkBreakdown] = useState([])
    const [rtooBreakdown, setRtooBreakdown] = useState([])
    const [rtcBreakdown, setRtcBreakdown] = useState([])
    const [rttBreakdown, setRttBreakdown] = useState([])
    const [tvlaBreakdown, setTvlaBreakdown] = useState([])
    const [isrBreakdown, setIsrBreakdown] = useState([])
    const [daBreakdown, setDaBreakdown] = useState([])
    const [requestor, setRequestor] = useState('All');
    const applicableRights = REQUEST_TYPES.filter(right => isReportRightApplicable(right.key, requestor));
     const [awlBreakdown, setAwlBreakdown] = useState([])
      const [rwlBreakdown, setRwlBreakdown] = useState([])
       const [ufvBreakdown, setUfvBreakdown] = useState([])
    const [totalBreakdown, setTotalBreakdown] = useState([])
    const [ticket_state, setTicketState] = useState(routeState?.ticket_state || "Open")
    const [reportHealth, setReportHealth] = useState({}) 

    const [openModel, setOpenModel] = useState(false)
    const [modelData, setModelData] = useState([])
    const [dialogAppName, setDialogAppName] = useState("")
    const [noOfDaysSelected, setNoOfDaysSelected] = useState("")
    const [ticketType, setTicketType] = useState("")

    const [downstreamMetrics, setDownstreamMetrics] = useState([])
    const [filterDownstreamMetrics, setFilterDownstreamMetrics] = useState([])

    const [age, setAge] = useState("")
 const [displayErrorMsg, setDisplayErrorMsg] = useState("");
    const [showAllRequests, setShowAllRequests] = useState(false);

    const open = ticket_state === "Open";
 const handleChange = (event)=>{
    setShowAllRequests(!showAllRequests)
 }

 const handleFilterDownStreamMetrics =()=>{
    const newData = downstreamMetrics.filter((item)=>{
         const totals = applicableRights.reduce((sum, right) => sum + item.data[right.columnMappingIndex], 0);
         return showAllRequests || totals > 0
    });
    setFilterDownstreamMetrics(newData)
 }

 useEffect(()=>{
    handleFilterDownStreamMetrics()
 },[downstreamMetrics, showAllRequests, requestor])
    useEffect(() => {
        if (routeState) {
            setTicketState(routeState.ticket_state);
        }
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[routeState?.ticket_state])

    useEffect(() => {
        if (authToken) {
            axios.get('/reports/aging', {
                params: {
                    is_open: open,
                    requestor,
                },
                headers: {
                    Authorization: authToken
                }
            }).then(res => {
                setRtdBreakdown(res.data.age.rtd)
                setRtkBreakdown(res.data.age.rtk)
                setRtooBreakdown(res.data.age.rtoo)
                setRtcBreakdown(res.data.age.rtc)
                setRttBreakdown(res.data.age.rtt)
                setTvlaBreakdown(res.data.age.tvla)
                setIsrBreakdown(res.data.age.isr)
                setDaBreakdown(res.data.age.deactivate_account)
                setAwlBreakdown(res.data.age.awl)
                setRwlBreakdown(res.data.age.rwl)
                setUfvBreakdown(res.data.age.ufv)
                setTotalBreakdown(res.data.age.total)
                setReportHealth({
                    days : res.data.oldest_dsar_age,
                    dsar : res.data.oldest_dsar
                })
                // Decide the default age for the downstream metrics
                let i = 3
                if (open) {
                    res.data.age.total.find((num, index) => {
                        if (num > 0) { i = index; return num }
                        return null;
                    })
                    setAge(metricAgeMapping[i])
                }
            }).catch(err => {
                console.log(err)
            })
        }
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[authToken, open, requestor])

    useEffect(() => {
        if (age !== "") {
            axios.get('/reports/aging/metrics', {
                params: {
                    metric_age: age,
                    requestor,
                },
                headers: {
                    Authorization: authToken,
                }
            }).then(res => {
                setDownstreamMetrics(res?.data?.metrics)
            }).catch(err => {
                console.log(err)
            })
        }
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[age, authToken, requestor])
    const downloadModelDsarIds = ()=>{
        if (modelData.length) {
            let csv = []
            for (const dsar_id of modelData) {
                csv.push({ "DSAR ID": dsar_id.dsar_id,
                    "Request Type": RequestTypeMapping[dsar_id.ticket_type],
                    "Requestor": dsar_id.requestor,
                    "Created Date": dsar_id.created_date ? moment(dsar_id.created_date).utc().format("MM/DD/YYYY") : '--',
                 });

            }
            const downloadLink = document.createElement("a");
            csv = Papa.unparse(csv)
            const blob = new Blob(["\ufeff", csv])
            const url = URL.createObjectURL(blob)
            downloadLink.href = url
            const timestamp = moment().format("YYYYMMDDHHmm")
            
           
             downloadLink.download = `Aging_Report_${dialogAppName ? dialogAppName: noOfDaysSelected}_${ticketType==="all" ? "Totals":ticketType}_${timestamp}.csv`
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
        }

    }
    const downloadDsarIds = () => {
        axios.get('/reports/aging/download', {
            params: {
                metric_age: age,
                is_open: open,
                requestor,
            },
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            if (res.data.old_dsar_ids.length) {
                let csv = []
                for (const dsar_id of res.data.old_dsar_ids) {
                    csv.push({ "DSAR ID": dsar_id });
                }
                const downloadLink = document.createElement("a");
                csv = Papa.unparse(csv)
                const blob = new Blob(["\ufeff", csv])
                const url = URL.createObjectURL(blob)
                downloadLink.href = url
                const timestamp = moment().format("YYYYMMDDHHmm")
                downloadLink.download = `Aging_Report_${age}_${ticket_state}_${timestamp}.csv`
                document.body.appendChild(downloadLink)
                downloadLink.click()
                document.body.removeChild(downloadLink)
            } else {
                setDisplayErrorMsg('No records to Download')
            }
        }).catch(err => {
            console.log(err)
            setDisplayErrorMsg(err.response.data.message)
        })
    }

     const handleClose = () => {
        setDisplayErrorMsg("");
    }

    const downloadQuery = (appName, ticketColIndex,appId) => {
        // Map the ticketType index to the actual value
        const ticketType = REQUEST_TYPES.find(right => right.columnMappingIndex === ticketColIndex).ticketType;

        axios.get('/reports/aging/download_query', {
            params: {
                app_id: appId,
                ticket_type: ticketType,
                download_total: true,
                metric_age: age,
                is_open: open,
                requestor,
            },
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            setOpenModel(true);
            setModelData(res.data.dsar_ids);
            setDialogAppName(appName);
            setNoOfDaysSelected("");
            setTicketType(ticketType);
        }).catch(err => {
            console.log(err)
        })
    }

    const downloadAgingQuery = (ageIndex, ticketType) => {
        // Map the ticketType & age index to the actual value
        ticketType = REQUEST_TYPES.find(right => right.columnMappingIndex === ticketType).ticketType;
        const ageMapping = ['11_plus', '7_10', '4_6', '0_3']
        const age = ageMapping[ageIndex]
        const displayDates = [`11+ Days (${todayUTC.clone().subtract(11, "days").format("MM/DD")} & earlier)`,
        `7-10 Days (${todayUTC.clone().subtract(10, "days").format("MM/DD")} - ${todayUTC.clone().subtract(7, "days").format("MM/DD")})`,
        `4-6 Days (${todayUTC.clone().subtract(6, "days").format("MM/DD")} - ${todayUTC.clone().subtract(4, "days").format("MM/DD")})`,
        `0-3 Days (${todayUTC.clone().subtract(3, "days").format("MM/DD")} - ${todayUTC.format("MM/DD")})`
        ]
        const display_age = displayDates[ageIndex]

        axios.get(`/reports/aging/download_${open ? "open" : "closed"}_query`, {
            params: {
                ticket_type: ticketType,
                metric_age: age,
                parse_json: true,
                requestor
            },
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            setNoOfDaysSelected(display_age);
            setDialogAppName("");
            setOpenModel(true);
            setModelData(res.data.dsar_ids);
        }).catch(err => {
            console.log(err)
        })
    }

    // eslint-disable-next-line no-unused-vars
    const populateError = (message) => {
        const downloadError = document.getElementById('downloadError')
        downloadError.innerHTML = message
        removeFeedback('downloadError')
    }

    const removeFeedback = (elementId) => {
        // Remove the feedback after a specified timeout period
        setTimeout(
            function () {
                const field = document.getElementById(elementId)
                if (!field) { return }
                field.innerHTML = ""
            }, feedbackTimeout
        )
    }
    const agingRows = [{
        id: 0,
        days: `11+ Days (${todayUTC.clone().subtract(11, "days").format("MM/DD")} & earlier)`,
        requestType: RequestTypeMapping['Right-to-Correct'],
        isr: isrBreakdown[0],
        da: daBreakdown?.[0],
        rtc: rtcBreakdown[0],
        tvla: tvlaBreakdown[0],
        rtd: rtdBreakdown[0],
        rtk: rtkBreakdown[0],
        rtoo: rtooBreakdown[0],
        rtt: rttBreakdown[0],
        awl: awlBreakdown[0],
        rwl: rwlBreakdown[0],
        ufv: ufvBreakdown[0],
        totals: totalBreakdown[0]
    }, {
        id: 1,
        days: `7-10 Days (${todayUTC.clone().subtract(10, "days").format("MM/DD")} - ${todayUTC.clone().subtract(7, "days").format("MM/DD")})`,
        isr: isrBreakdown[1],
        da: daBreakdown?.[1],
        rtc: rtcBreakdown[1],
        tvla: tvlaBreakdown[1],
        rtd: rtdBreakdown[1],
        rtk: rtkBreakdown[1],
        rtoo: rtooBreakdown[1],
        rtt: rttBreakdown[1],
        awl: awlBreakdown[1],
        rwl: rwlBreakdown[1],
        ufv: ufvBreakdown[1],
        totals: totalBreakdown[1]
    }, {
        id: 2,
        days: `4-6 Days (${todayUTC.clone().subtract(6, "days").format("MM/DD")} - ${todayUTC.clone().subtract(4, "days").format("MM/DD")})`,
        isr: isrBreakdown[2],
        da: daBreakdown?.[2],
        rtc: rtcBreakdown[2],
        tvla: tvlaBreakdown[2],
        rtd: rtdBreakdown[2],
        rtk: rtkBreakdown[2],
        rtoo: rtooBreakdown[2],
        rtt: rttBreakdown[2],
        awl: awlBreakdown[2],
        rwl: rwlBreakdown[2],
        ufv: ufvBreakdown[2],
        totals: totalBreakdown[2]
    }, {
        id: 3,
        days: `0-3 Days (${todayUTC.clone().subtract(3, "days").format("MM/DD")} - ${todayUTC.format("MM/DD")})`,
        isr: isrBreakdown[3],
        da: daBreakdown?.[3],
        rtc: rtcBreakdown[3],
        tvla: tvlaBreakdown[3],
        rtd: rtdBreakdown[3],
        rtk: rtkBreakdown[3],
        rtoo: rtooBreakdown[3],
        rtt: rttBreakdown[3],
        awl: awlBreakdown[3],
        rwl: rwlBreakdown[3],
        ufv: ufvBreakdown[3],
        totals: totalBreakdown[3]
    }];

    const downstreamColumns = [
        { name: 'App Name', mapping: 'name', width: 150, sortable: false, frozen: true },
        ...applicableRights.map((rt) => ({
            name: rt.abbr,
            mapping: rt.key,
            width: 30,
            sortable: false,
            renderCell: (params) => {
                const val = params.value || 0;
                return val > 0 ? (
                    <button
                        className="btngridcel btn btn-link p-0"
                        onClick={(e) => {
                            e.stopPropagation();
                            downloadQuery(params.row.name, rt.columnMappingIndex, params.row.app_id);
                        }}
                    >
                        {val}
                    </button>
                ) : val;
            },
        })),
        {
            name: 'Totals',
            mapping: 'totals',
            width: 50,
            sortable: false,
            valueGetter: (params) => {
                return applicableRights.reduce((sum, rt) => sum + (params.row[rt.key] || 0), 0);
            },
        },
    ];

    const downstreamRows = filterDownstreamMetrics?.map((dm) => ({
        id: dm.name,
        app_id: dm.id,
        name: dm.name,
        ...mapReportValues(dm.data),
    })) || [];

    return (
        <div className={`mb-5 ${classes.root}`}>
            <Typography variant="h6" className={`${classes.agingReportHeader}`}>
                REQUESTS AGING REPORT
            </Typography>
            <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
            >
                <Box flex={1}>
                    <label style={{ fontWeight: 'bold', display: 'block', marginLeft: '10px', fontSize: '0.85rem' }}>Request Status</label>
                    <ToggleButtonGroup
                        value={ticket_state}
                        exclusive
                        onChange={(event, newValue) => {
                            if (newValue !== null) {
                                setTicketState(newValue);
                            }
                        }}
                        className={classes.toggleButtonGroup}
                    >
                        <ToggleButton value="Open">Open</ToggleButton>
                        <ToggleButton value="Closed">Closed</ToggleButton>
                    </ToggleButtonGroup>
                </Box>
                { open && (<Box marginRight={"10px"}>
                    <Box>
                        <b>Max Age:</b> {reportHealth?.days || "--"} days
                    </Box>
                    <Box>
                        <b>Oldest DSAR: </b>
                        <Link to={`${v2UIRoutePath}requestdetails/${reportHealth?.dsar}`}>
                             {reportHealth?.dsar || "--"}
                        </Link>
                        
                    </Box>
                </Box> )}
            </Box>

            <FormGroup
                fields={[{
                    type: 'multiselect',
                    name: 'requestor',
                    label: 'Requestor',
                    removeCheckBox: true,
                    options: ['All', ...Object.values(RequestorMapping)],
                    defaultOption: 'All',
                }]}
                disableFormActions={true}
                customFormUpdates={formData => setRequestor(formData.requestor)}
            />
            {(() => {
                const ageDateLabels = agingRows.map(r => r.days);
                const handleAgingCellClick = (ageIndex, columnMappingIndex) => {
                    downloadAgingQuery(ageIndex, columnMappingIndex);
                };
                return <CardLayoutView agingRows={agingRows} ageDateLabels={ageDateLabels} onCellClick={handleAgingCellClick} requestTypes={applicableRights} />;
            })()}
            {open && (
                <div>
                    <Typography variant="h6" className={`${classes.downstreamMetricsHeader}`}>
                        <form className="form-inline">
                            Downstream Metrics for
                            <select className="form-control form-control-inline form-inline mx-2"
                                value={age} onChange={e => setAge(e.target.value)}
                            >
                                <option value="0_3">0-3</option>
                                <option value="4_6">4-6</option>
                                <option value="7_10">7-10</option>
                                <option value="11_plus">11+</option>
                            </select>
                            days old Requests
                            <div style={{ flex: 1, display: 'flex', marginRight: '40px', alignItems: 'end', justifyContent: 'end' }}>
                                <Tooltip title="Download Request Details" aria-label="Download Request Details">
                                    <IconButton onClick={() => { downloadDsarIds() }} data-testid="downloadDsarids">
                                        <GetAppIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
    
                        </form>

                    </Typography>
                    <FormControlLabel control={
                        <Checkbox 
                            checked={showAllRequests}
                            onChange={handleChange}
                            color="primary"
                            data-testid="showAllRequests"
                        />}
                        label="All downstream apps" />
                    <CustomGrid
                        columns={downstreamColumns}
                        rows={downstreamRows}
                        enableCustomFiltering={false}
                        showFilterButton={false}
                        showPagination={false}
                        showDownloadButton={false}
                        customHeight="500px"
                    />
                </div>
            )}
              <Snackbar open={!!displayErrorMsg} autoHideDuration={6000} onClose={handleClose}>
                            <Alert onClose={handleClose} severity="error">
                                {displayErrorMsg}
                            </Alert>
                        </Snackbar>
            <>
            {openModel && <Dialog
            isOpen={true}
            updateDialogStatus={() => {
                setOpenModel(false);
            }}
            dialogContent={<ReportPopup modelData={modelData} />}
            title={(
                <div className={classes.dialogheader}>
                <div className='modelheader'>{open ? "Open " : "Closed"} Requests</div>
                {dialogAppName !== "" ? (<>
                    <span> App Name </span> : {dialogAppName}
                </>) : (<>
                    <span> No. of Days </span> : {noOfDaysSelected}
                </>)}
                <div style={{ flex: 1, display: 'flex', marginRight: '40px', alignItems: 'end', justifyContent: 'end' }}>
                                <Tooltip title="Download Request Details" aria-label="Download Request Details">
                                    <IconButton onClick={() => { downloadModelDsarIds() }}>
                                        <GetAppIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>

            </div>
            )}
        />}
        
            </>
        </div>
    );
}

export default AgingReport;

const metricAgeMapping = {
    0: "11_plus",
    1: "7_10",
    2: "4_6",
    3: "0_3",
}